const pos = {
  pos: 'POS',
  create: 'Create new POS',
  add: 'Add new POS',
  code: 'POS Code',
  id: 'ID',
  name: 'Branch',
  empty: 'No POS created yet',
  pending: 'Pending action successful',
  active: 'POS activated',
  ban: 'POS blocked',
  user:'User',
  form: {
    select: 'Select branch',
    name: {
      label: 'POS Name',
      placeholder: 'Enter POS name'
    },
    pending: 'Mark as pending',
    ban: {
      text: 'Block',
      successMsg: 'POS blocked successfully',
      prompt: 'Taking this action will prevent other users from accessing information related to this POS. Do you want to block POS?',
      title: 'Block POS'
    },
    activate: {
      text: 'Activate',
      successMsg: 'POS activated successfully',
      prompt: 'Taking this action will enable other users to access information related to this POS. Do you want to activate POS?',
      title: 'Activate POS'
    },
    edit: {
      text: 'Edit',
      successMsg: 'POS edited successfully'
    },
  },

  management: {
    page_title: 'POS Management',
    add: 'Add POS Device',
    edit: 'Edit POS Device',
    disable: 'Disable POS Device',
    enable: 'Enable POS Device',
    delete: 'Delete POS Device',
    view_details: 'View Detail',
    last_update: 'Last update: {{date}}',
    empty_title: 'No POS devices yet',
    empty_hint: 'POS devices will appear here once they’re added.',
    disable_title: 'Disable POS',
    enable_title: 'Enable POS',
    delete_title: 'Delete POS',
    disable_confirm: 'This will disable this POS and prevent it from processing transactions.',
    enable_confirm: 'This will re-enable this POS and allow it to process transactions again.',
    delete_confirm: 'This will permanently delete this POS. This action can\'t be undone',
    success_create: 'POS device added successfully',
    success_edit: 'POS device updated successfully',
    success_disable: 'POS disabled successfully',
    success_enable: 'POS enabled successfully',
    success_delete: 'POS deleted successfully',

    stats: {
      total: 'Total POS Devices',
      total_hint: 'All registered devices',
      active: 'Active Devices',
      active_hint: 'Currently online',
      inactive: 'Inactive Devices',
      inactive_hint: 'Currently offline',
      unassigned: 'Unassigned Devices',
      unassigned_hint: 'Not assigned to branch'
    },

    filters: {
      search_placeholder: 'Search by POS name',
      all_branches: 'All branches',
      all_device_models: 'All device models',
      all_statuses: 'All statuses',
      search_branch_placeholder: 'Search branch',
      active: 'Active',
      inactive: 'Inactive'
    },

    table: {
      header: {
        pos_id: 'POS ID',
        branch: 'Branch',
        assigned_operator: 'Assigned Operator',
        device_model: 'Device Model',
        last_sync: 'Last Sync',
        status: 'Status'
      },
      selected: '{{count}} of {{total}} row(s) selected.',
      page_of: 'Page {{page}} of {{total}}',
      never_synced: 'Never'
    },

    form: {
      serial_number: {
        label: 'Serial Number',
        placeholder: 'Enter serial number'
      },
      device_model: {
        label: 'Device Modal',
        placeholder: 'Select device model'
      },
      device_type: {
        label: 'Device Type',
        placeholder: 'Select device type'
      },
      software_version: {
        label: 'Software Version',
        placeholder: 'eg. v2.3.1'
      },
      activation_date: {
        label: 'Activation Date',
        placeholder: 'DD/MM/YYYY'
      },
      photo: {
        label: 'Device Photo',
        upload: 'Upload',
        hint: 'PDF, JPEG, or PNG less than 3MB'
      },
      branch_id: {
        label: 'Branch',
        placeholder: 'Select branch'
      },
      user_id: {
        label: 'Assigned Operator',
        placeholder: 'Select operator'
      }
    }
  }
};

export default pos;